import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFaqQuestionsByCategoryId = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-questions/get-by-category-id', request);
};
const getFaqQuestionById = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-questions/get-by-id', request);
};
const createFaqQuestion = (request) => {
    return vdkEmHappinessPortalApi.post('/faq-questions/create', request);
};
const updateFaqQuestion = (request) => {
    return vdkEmHappinessPortalApi.put('/faq-questions/update', request);
};
const updateFaqQuestionWithCategory = (request) => {
    return vdkEmHappinessPortalApi.put('/faq-questions/update-faq-question-with-category', request);
};
const deleteFaqQuestion = (request) => {
    return vdkEmHappinessPortalApi.delete('/faq-questions/delete', {
        data: request
    });
};
const reorderFaqQuestions = (request) => {
    return vdkEmHappinessPortalApi.put('/faq-questions/reorder', request);
};
const faqQuestionApi = {
    getFaqQuestionsByCategoryId,
    getFaqQuestionById,
    createFaqQuestion,
    updateFaqQuestion,
    updateFaqQuestionWithCategory,
    deleteFaqQuestion,
    reorderFaqQuestions
};
export default faqQuestionApi;
